import _ from 'lodash';
import { convertHelpers } from '../../../../../global/common/convert';
import { dataFix } from '../../../../../global/common/dataFix';
import { reorderDateStrings } from '../../../../../global/common/sorting';
import { createScheduledMatches } from '../../../dbActions/updateSeasonSchedule';
import { sectionCountTypes } from '../CreateSportsReducer';

export const createSportsHelpers = {
  addTeamInfoToTeamRosters: (rosters, existingTeams) => addTeamInfoToTeamRosters(rosters, existingTeams),
  ammend_currentPlayoffInfo: (playoff_info, playoffGroupKey, action) => ammendCurrentPlayoffInfo(playoff_info, playoffGroupKey, action),
  // ammend_currentSeasonInfo: (state, crossoverOn) => ammendCurrentSeasonInfo(state, crossoverOn),
  ammend_levelSectionsFromCounts: (levels_info, sectionCounts, levelKey, sectionCount) => ammendLevelSectionsFromCounts(levels_info, sectionCounts, levelKey, sectionCount),
  ammend_lstsFromTeams: (teams, lsts, forHomeAway) => ammendLstsFromTeams(teams, lsts, forHomeAway),
  ammend_playoffDatesNeeded: (playoffLevelTeams) => ammendPlayoffDatesNeeded(playoffLevelTeams),
  ammend_playoffMatchCounts: (playoffLevelTeams) => ammendPlayoffMatchCounts(playoffLevelTeams),
  ammend_playoffSeedingMismatch: (playoffLevelTeams) => ammendPlayoffSeedingMismatch(playoffLevelTeams),
  ammend_something: (state, action) => ammendSomething(state, action),
  ammend_sportsDataFromResult: (_sportsData, action) => ammendSportsDataFromResult(_sportsData, action),
  ammend_team: (teamKey, team, sportsYears) => ammendTeam(teamKey, team, sportsYears),
  assign_recordsToTeams: (playoffLevelTeams, _playoffInfo) => assignRecordsToTeams(playoffLevelTeams, _playoffInfo),
  cleanUpPlayoffSeeding: (playoffLevelTeams) => cleanUpPlayoffSeeding(playoffLevelTeams),
  createLevelsAndSections: (levels, sections, levels_info) => createLevelsAndSections(levels, sections, _levels_info),
  createTheSeasonMatches: (database_fns, mainDb, seasonMatchesProps, matches_season) => createTheSeasonMatches(database_fns, mainDb, seasonMatchesProps, matches_season),
  getCurrentSeasonInfo: (state, action) => getCurrentSeasonInfo(state, action),
  getFullPlayoffInfo: (playoff_matchInfo, playoffLevel, allPlayoffLevels) => getFullPlayoffInfo(playoff_matchInfo, playoffLevel, allPlayoffLevels),
  getPlayoffLevelTeamz: (playoffLevelTeams) => getPlayoffLevelTeamz(playoffLevelTeams),
  getRankingData: (action) => getRankingData(action),
  getSectionCounts: (levels_info) => getSectionCounts(levels_info),
  get_selectedPlayoffInfo: (state) => getSelectedPlayoffInfo(state),
  getSelectedTeams: (teams_seasonal, state, levels_info, forSeason) => getSelectedTeams(teams_seasonal, state, levels_info, forSeason),
  getSelectedTeamsFromSchools: (schools, teams) => getSelectedTeamsFromSchools(schools, teams),
  getSportsDataInfo: (schoolsOrTeams, _selectedIndexes, teams_seasonal) => getSportsDataInfo(schoolsOrTeams, _selectedIndexes, teams_seasonal),
  getTeamCountOptions: (activeLevelsAndSections) => getTeamCountOptions(activeLevelsAndSections),
  getTeamsFromLevelSections: (levels_info, seasonal_current) => getTeamsFromLevelSections(levels_info, seasonal_current),
  add_playoffLevelTeam: (playoffInfo, playoffGroupKey, team, removeTeam) => addPlayoffLevelTeam(playoffInfo, playoffGroupKey, team, removeTeam),
}

const addPlayoffLevelTeam = (playoffInfo, playoffGroupKey, team, removeTeam) => {

  const { playoffLevelTeams } = playoffInfo ?? {};
  const _teams = playoffLevelTeams?.[playoffGroupKey];

  if (!_teams) return playoffLevelTeams; // Ensure _teams exists

  if (removeTeam) {
    // Remove the team based on id
    _.remove(_teams, { _itemKey: team._itemKey });
  } else {
    const _team = _.cloneDeep(team);
    const lastTeam = _.last(_teams);
    const lastTeamPosition = _.get(lastTeam, 'position', 0);

    _team.position = lastTeamPosition + 1;
    _team.seed = _team.position + 1;
    _team.owp = _.get(_team, 'record.owp', 0).toFixed(2);
    delete _team.record;

    _teams.push(_team);
  }

  return playoffLevelTeams;

}

const createSeededTeamsFromSectionRank = (teams) => {
  const _seededTeams = {}
  _.forEach(teams, (team, index) => {
    const { id, name, levels, sections, record, seed } = team
    const _position = seed ? seed : index
    const { sectionRank } = record ?? {}
    _seededTeams[id] = {
      id: id,
      _itemKey: id,
      name: name,
      levels: levels,
      sections: sections,
      record: {
        ...record,
        sectionRank,
      },
      seed: _position,
      position: _position,
    }
  })
  return _seededTeams
}

const ammendPlayoffMatchCounts = (playoffLevelTeams) => {
  const playoffMatches_expected = {};

  const matchesNeeded = (teamCount) => {
    if (teamCount <= 1) return { totalMatches: 0, breakdown: [] };

    // Find the next power of 2 above teamCount
    const nextPowerOfTwo = Math.pow(2, Math.ceil(Math.log2(teamCount)));

    // The number of byes
    const byes = nextPowerOfTwo - teamCount;

    const breakdown = [];
    let teamsInRound = teamCount;

    // Handle the initial "play-in" round if not a power of 2
    if (byes > 0) {
      const playInMatches = teamCount - (nextPowerOfTwo / 2);
      breakdown.push(playInMatches);
      teamsInRound = nextPowerOfTwo / 2; // winners advance to roundOf16 equivalent
    }

    // Handle subsequent rounds (standard power-of-two bracket)
    while (teamsInRound >= 2) {
      const matches = teamsInRound / 2;
      breakdown.push(matches);
      teamsInRound = matches;
    }

    const totalMatches = _.sum(breakdown);

    return { totalMatches, breakdown };
  };

  if (playoffLevelTeams) {
    _.forEach(playoffLevelTeams, (teams, levelKey) => {
      const teamCount = _.size(teams);
      playoffMatches_expected[levelKey] = matchesNeeded(teamCount);
    });
  }

  return playoffMatches_expected;
};


const ammendPlayoffDatesNeeded = (playoffLevelTeams) => {

  const playoffDates_selected = {}
  const playoffDates_ready = {}
  const playoffDates_needed = {}

  const datesNeeded = (teamCount) => {
    switch (true) {
      case teamCount > 16 && teamCount <= 32:
        return 5
      case teamCount > 8 && teamCount <= 16:
        return 4
      case teamCount > 4 && teamCount <= 8:
        return 3
      case teamCount > 3 && teamCount <= 4:
        return 2
      default:
      // nothing
    }
  }

  if (playoffLevelTeams) {
    _.forEach(playoffLevelTeams, (lt, key) => {
      playoffDates_selected[key] = []
      playoffDates_ready[key] = false
      playoffDates_needed[key] = datesNeeded(_.size(lt))
    })
  }

  return { playoffDates_selected, playoffDates_ready, playoffDates_needed }

}

const getPlayoffLevelTeamz = (playoffLevelTeams) => {
  const _plts = {}
  if (playoffLevelTeams) {
    _.forEach(playoffLevelTeams, (level, levelKey) => {
      _plts[levelKey] = []
      const _teams = _.sortBy(level, 'seed')
      _.forEach(_teams, (team) => {
        _plts[levelKey].push(team._itemKey)
      })
    })
  }
  return _plts
}

/**
 * Finds teams with a matching parentKeys.schools
 * @param {*} schools 
 * @param {*} teams 
 * @returns selected, nonSelected, selectedIndexes
 */
const getSelectedTeamsFromSchools = (schools, teams) => {

  const selected = {}
  const nonSelected = {}
  const selectedIndexes = []

  if (schools && teams) {
    _.forEach(schools, (school, sk) => {
      const teamKey = _.findKey(teams, function (t) { return t.parentKeys && t.parentKeys['schools'] === sk; })
      if (teamKey) {
        selected[teamKey] = teams[teamKey]
        selectedIndexes.push(sk)
      } else {
        nonSelected[teamKey] = teams[teamKey]
      }
    })
  }
  return { selected, nonSelected, selectedIndexes }
}

const assignRecordsToTeams = (playoffLevelTeams, _playoffInfo) => {

  const { playoffTeams_standings } = _playoffInfo ?? {}

  _.forEach(playoffLevelTeams, (teams, levelKey) => {
    _.forEach(teams, (team) => {
      const t = _.find(playoffTeams_standings, { id: team.id })
      if (t?.record?.owp) {
        team.owp = t?.record?.owp.toFixed(2)
      }
    })
  })
}

const ammendPlayoffSeedingMismatch = (playoffLevelTeams) => {

  _.forEach(playoffLevelTeams, (teams) => {

    const totalTeams = _.size(teams);
    // 🔹 Find nearest bracket size (8, 16, 32, 64...)
    const bracketSize = _.find([4, 8, 16, 32, 64], (b) => totalTeams <= b) || totalTeams;

    // 🔹 Create seed matchups (1 vs bracketSize, 2 vs bracketSize-1, etc.)
    const seedPairs = _.range(1, Math.ceil(bracketSize / 2) + 1).map((seed) => ({
      h: seed - 1, // zero-indexed
      a: bracketSize - seed,
    }));

    _.forEach(seedPairs, ({ h, a }) => {
      const home = teams[h];
      const away = teams[a];

      // Skip if one of the seeds doesn’t exist (bye)
      if (!home || !away) return;

      // 🔹 Mark bad seeds if from the same section
      const sameSection = home.sections && away.sections && home.sections === away.sections;
      home.badSeed = sameSection ? home.sections : false;
      away.badSeed = sameSection ? home.sections : false;
    });
  })
}

const cleanUpPlayoffSeeding = (playoffLevelTeams) => {

  const seedTests = []
  const max = 15
  const halfMax = 7

  for (let i = 0; i <= halfMax; i++) {
    seedTests.push({ h: i, a: max - i })
  }

  Object.keys(playoffLevelTeams).forEach(k => {
    const teams = playoffLevelTeams[k]
  })
}

const ammendSomething = (state, action) => {
  // teams_all
  const { pathViews, teams_info, schools_info, teamsFromSchools } = state
  const { teams_existing } = action ?? {}
  const _data = updateTeamsSelected(teams_info, schools_info, teams_existing, teamsFromSchools)
  if (teamsFromSchools) {
    const { teams: _teamsExisting1 } = getTeamsFromSelectedData(_data, pathViews, teamsFromSchools ? false : true)
    const du1 = { ...state.seasonal_current, teams: _teamsExisting1 }
    return { ...state, schools_info: _data, seasonal_current: du1 }
  } else {
    const { teams: _teamsExisting2 } = getTeamsFromSelectedData(_data, pathViews, teamsFromSchools ? false : true)
    const du2 = { ...state.seasonal_current, teams: _teamsExisting2 }
    console.log('ammendSomething', _data)
    return { ...state, teams_info: _data, seasonal_current: du2 }
  }
}

const createLevelsAndSections = (levels, sections, _levels_info) => {

  const _levels = Object.assign({}, levels)
  const _sections = Object.assign({}, sections)

  if (_levels && _sections) {
    const ls = {}
    _.forEach(_levels, (level, lk) => {
      ls[level._itemKey] = { name: level.name, checked: false, sections: {} }
      Object.keys(_sections).forEach(sk => {
        const section = _sections[sk]
        if (section.name !== 'Non-Section') {
          ls[level._itemKey].sections[section._itemKey] = { name: section.name, checked: false }
        }
      })
    })
    const _existing = _.cloneDeep(ls)
    const _next = _.cloneDeep(ls)
    _levels_info.existing = _existing
    _levels_info.next = _next
    const _tc = getTeamCountOptions(_.pickBy(_next, { checked: true }))
    return { levels_info: _levels_info, teamCounts: _tc }
  }
  return {}
}

const ammendSportsDataFromResult = (_sportsData, action) => {

  const { dataResult } = action
  const { levels, schools, sections, teams } = dataResult ?? {}

  if (levels) {
    convertHelpers.createItemKeys(levels)
    _sportsData['levels'] = levels
  }

  if (sections) {
    convertHelpers.createItemKeys(sections)
    _sportsData['sections'] = _.sortBy(sections, '_itemKey')
  }

  if (teams) {
    _sportsData['teams'] = teams
    _sportsData['teams_district_sports'] = teams
  }

  if (schools) {
    getSchoolsWithTeams(schools, teams)
    _sportsData['schools'] = schools
  }

  const _teamsInfo = getSelectedTeamsFromSchools(schools, teams)

  const _school_data = getSportsDataInfo(schools, _teamsInfo.selectedIndexes)
  const _teams = teams ? teams : _school_data.existing
  const _hasTeams = teams ? true : false

  return { _teams, _hasTeams, _school_data }
}

const ammendLevelSectionsFromCounts = (levels_info, sectionCounts, levelKey, sectionCount) => {
  const { next } = levels_info
  const _next = { ...next }
  if (sectionCounts && !_.isNumber(sectionCounts)) {
    Object.keys(sectionCounts).forEach(lk => {
      const _sectionCount = sectionCounts[lk]
      ammendNext(_next, lk, _sectionCount)
    })
  } else if (levelKey && sectionCount) {
    ammendNext(_next, levelKey, sectionCount)
  }
  levels_info.next = _next
}

const getTeamsFromLevelSections = (levels_info, seasonal_current) => {
  const _teams = seasonal_current && seasonal_current.teams ? seasonal_current.teams : {}
  const { next } = levels_info
  if (next) {
    Object.keys(next).forEach(levelKey => {
      const level = next[levelKey]
      const { sections } = level ?? {}
      if (sections) {
        Object.keys(sections).forEach(sectionKey => {
          const section = sections[sectionKey]
          const { teams } = section ?? {}
          if (teams) {
            Object.keys(teams).forEach((teamKey, index) => {
              const team = teams[teamKey]
              const { id, _itemKey, position, name } = team ?? {}
              const _id = _itemKey ? _itemKey : id
              _teams[_id] = {
                levels: levelKey,
                sections: sectionKey,
                position: _.isNaN(position) || _.isUndefined(position) ? index : position,
                name
              }
            })
          }
        })
      }
    })
  }
  return { teams: _teams }
}

const getRankingData = (action) => {
  const { actionProps } = action
  const { selectedLevel, selectedWeek, sortedLevels } = actionProps
  const sortedLevel = sortedLevels[selectedLevel]
  const teams = []

  sortedLevel.forEach((sl, index) => {
    if (index < 10) { teams.push(sl.name) }
  })

  const data_rankings = {}
  data_rankings['rankings' + '.' + selectedWeek + '.' + selectedLevel] = teams;

  return data_rankings
}

const getSectionCounts = (levels_info) => {
  const _sectionCounts = {}
  const { next } = levels_info
  if (next) {
    Object.keys(next).forEach(levelKey => {
      const level = next[levelKey]
      const { sectionCount } = level ?? {}
      if (sectionCount > 0) {
        _sectionCounts[levelKey] = sectionCount
      }
    })
  }
  return _sectionCounts
}

/**
 * 
 * @param {object} teams 
 * @param {object} lsts 
 * @returns updates the levels/sections with their teams
 */
const ammendLstsFromTeams = (teams, lsts, forHomeAway) => {
  const homeAways = {}
  let ready_alignment = false;
  let groupedLevels = _.groupBy(teams, 'levels')
  if (lsts && groupedLevels) {
    Object.keys(groupedLevels).forEach(lvKey => {
      const level = groupedLevels[lvKey]
      const selectedLevel = _.find(lsts, { name: lvKey })
      if (selectedLevel) {
        const _sections = []
        selectedLevel.checked = true
        const { sections } = selectedLevel
        let groupedSections = _.groupBy(level, 'sections')
        if (groupedSections) {
          Object.keys(groupedSections).forEach(sKey => {
            let selectedSection = _.find(sections, { name: sKey })
            if (!selectedSection) {
              selectedSection = _.find(sections, { name: _.startCase(sKey) })
            }
            if (selectedSection) {
              selectedSection.checked = true
              _sections.push(_.camelCase(sKey))
              const _teams = _.filter(teams, { levels: lvKey, sections: sKey })
              const _levelSectionKey = lvKey + '_' + sKey
              selectedSection.teams = _teams
              ready_alignment = true
              homeAways[_levelSectionKey] = true
            }
          })
        }
      }
    })
  }
  if (forHomeAway) {
    return { ready_alignment, homeAways }
  } else {
    return ready_alignment
  }
}

const addTeamInfoToTeamRosters = (rosters, existingTeams) => {
  const _mergedData = []
  // adding the parentKey info to each of the data items
  Object.keys(rosters).forEach(rdKey => {
    const rosterGroup = rosters[rdKey]
    const { parentKeys } = rosterGroup
    const { teams } = parentKeys ?? {}
    const rdiData = rosterGroup['athletes']
    Object.keys(rdiData).forEach(keyy => {
      if (teams) { rdiData[keyy].teams = teams }
      if (existingTeams) {
        const t = _.find(existingTeams, { id: teams })
        if (t) {
          const { name, levels, sections } = t
          if (levels) { rdiData[keyy].levels = levels }
          if (sections) { rdiData[keyy].sections = sections }
          if (name) { rdiData[keyy].teams = name }
          rdiData[keyy].key = keyy
        }
      }
      _mergedData.push(rdiData[keyy])
    })
  })
  return _mergedData
}

const ammendTeam = (teamKey, team, sportsYears) => {
  let { parentKeys } = team
  if (!parentKeys) { parentKeys = {} }
  parentKeys.sportsYears = sportsYears
  return {
    levels: team.levels,
    sections: team.sections,
    schools: team.schools,
    name: team.name,
    parentKeys: team.parentKeys,
    id: team.id ? team.id : teamKey,
    _itemKey: team.id ? team.id : teamKey,
    position: team.position
  }
}

const getTeamCountOptions = (activeLevelsAndSections) => {
  const optsA = []
  if (activeLevelsAndSections) {
    Object.keys(activeLevelsAndSections).forEach(key => {
      const ls = activeLevelsAndSections[key]
      if (ls && ls.sections)
        Object.keys(ls.sections).forEach(skey => {
          const section = ls.sections[skey]
          const { teams } = section ?? {}
          if (teams) {
            if (teams.length > 1) {
              if (!optsA.includes(teams.length)) {
                optsA.push(teams.length)
              }
            }
          }
        })

    })
  } else {
    for (var i = 3; i <= 10; i++) {
      optsA.push(i + ' Teams')
    }
  }
  return optsA.sort()
}


/**
* 
* @param {object} state 
* @param {object} action  
* }
*/
const getCurrentSeasonInfo = (state, action) => {

  const { seasonDateProps } = action ?? {}
  const { selectedDates, selectedCSDates, selectedSection } = seasonDateProps ?? {}

  const _selectedSection = selectedSection

  const { sportsSeason_selected } = state
  const { seasonals } = sportsSeason_selected ?? {}
  const { sectionDates, crossSectionDates } = seasonals ?? {}

  const _forCrossSection = selectedCSDates ? true : false
  const _selectedDates = _forCrossSection ? selectedCSDates : selectedDates

  let _seasonDates = _forCrossSection ? crossSectionDates : sectionDates

  if (!_seasonDates) { _seasonDates = {} }
  if (!_seasonDates[_selectedSection]) { _seasonDates[_selectedSection] = [] }
  if (_seasonDates && _seasonDates?.[_selectedSection]) { _seasonDates[_selectedSection] = _selectedDates }

  if (_forCrossSection) {
    seasonals.crossSectionDates = _seasonDates
  } else {
    seasonals.sectionDates = _seasonDates
  }

  return sportsSeason_selected

}

/**
 * 
 * @param {object} state (currentLevelKey,playoff_info )
 * @param {object} action (playoffDateProps, levelKey)
 * @returns 
 */
const ammendCurrentPlayoffInfo = (playoff_info, playoffGroupKey, action) => {

  const { playoffDateProps } = action ?? {}
  const { selectedDates } = playoffDateProps ?? {}

  let _playoff_info = _.cloneDeep(playoff_info)
  if (!_playoff_info) { _playoff_info = {} }

  const { playoffDates_selected, playoffDates_needed } = _playoff_info ?? {}

  if (selectedDates) {
    playoffDates_selected[playoffGroupKey] = selectedDates
  }

  _playoff_info.playoffDatesAreReady = ammendPlayoffDatesReady(_playoff_info)

  if (playoffGroupKey) {
    _playoff_info.playoffDates_current = {
      currentNeeded: playoffDates_needed[playoffGroupKey],
      currentCount: playoffDates_selected[playoffGroupKey] ? playoffDates_selected[playoffGroupKey].length : 0,
      currentDates: playoffDates_selected[playoffGroupKey] ? playoffDates_selected[playoffGroupKey] : [],
      currentLevelKey: playoffGroupKey
    }
  }

  return _playoff_info

}

const ammendPlayoffDatesReady = (playoff_info) => {
  let _playoffDatesReady = true
  const { playoffLevelTeams, playoffDates_selected, playoffDates_ready, playoffDates_needed } = playoff_info ?? {}
  const playoffLevelKeys = playoffLevelTeams ? Object.keys(playoffLevelTeams) : []
  playoffLevelKeys.forEach(plk => {
    playoffDates_ready[plk] = playoffDates_selected && playoffDates_selected[plk] && playoffDates_needed && (playoffDates_selected[plk].length === playoffDates_needed[plk])
    if (!playoffDates_ready[plk]) {
      _playoffDatesReady = false
    }
  })
  return _playoffDatesReady
}

/**
 * 
 * @param {object} teams_seasonal 
 * @param {object} sportsSeason_data 
 * @param {object} sportsDetails 
 * @param {object} levels_info 
 * @param {boolean} forSeason 
 * @returns 
 */
const getSelectedTeams = (teams_seasonal, state, levels_info, forSeason) => {

  const { sportsDetails, sportsSeason_data } = state
  const { existing, next } = levels_info
  const { schools: schools_sd } = sportsSeason_data

  const { sportsYears } = sportsDetails ?? {}

  let playoff_teamz = _.filter(teams_seasonal, function (st) { return st.record && st.record.playoffTeam })

  const _selectedSchoolIndexes = []
  const _selectedTeams = {}
  const _selectedTeamIndexes = []

  let _homeAways;
  let ready_levels;

  const _teams = {}

  if (teams_seasonal) {
    Object.keys(teams_seasonal).forEach((teamKey) => {
      _teams[teamKey] = ammendTeam(teamKey, teams_seasonal[teamKey], sportsYears)
    })
  }

  if (forSeason) {
    Object.keys(_teams).forEach((teamKey) => {
      _selectedTeamIndexes.push(teamKey)
      _selectedTeams[teamKey] = _teams[teamKey]
    })

    if (schools_sd) {
      Object.keys(_teams).forEach((teamKey) => {
        const t = _teams[teamKey]
        const { name: n } = t
        const selectedSchoolIndex = _.findIndex(schools_sd, { name: n })
        _selectedSchoolIndexes.push(selectedSchoolIndex)
      })
    }

    ammendLstsFromTeams(_teams, existing, true)

    const { ready_alignment, homeAways } = ammendLstsFromTeams(_teams, next, true)

    ready_levels = ready_alignment
    _homeAways = homeAways

  } else {
    Object.keys(_teams).forEach((teamKey, index) => {
      if (index < 16) {
        _selectedTeamIndexes.push(index)
        _selectedTeams[teamKey] = _teams[teamKey]
      }
    })
  }

  return {
    _selectedSchoolIndexes,
    _selectedTeamIndexes,
    _selectedTeams,
    homeAways: _homeAways,
    levels_info,
    playoff_teamz,
    ready_levels,
  }
}

const getSportsDataInfo = (schoolsOrTeams, _selectedIndexes, teams_seasonal) => {

  const sportsData = {
    existing: {},
    selected: {},
    nonSelected: {},
  }

  if (schoolsOrTeams) {
    // loop the schools or teams
    _.forEach(schoolsOrTeams, (si, key) => {
      const { name, _itemKey, _teamKey } = si
      const _key = _itemKey ? _itemKey : key
      const checked = _selectedIndexes && _selectedIndexes.includes(_key)
      sportsData.existing[_key] = { key, name, checked, _itemKey: _key, _teamKey, disabled: _teamKey ? false : false }
    })
  }

  if (sportsData.existing) {
    _.forEach(sportsData.existing, (item, key) => {
      const { checked, _itemKey } = item
      const ts = teams_seasonal && teams_seasonal[_itemKey]
      const _selOrNon = checked ? sportsData.selected : sportsData.nonSelected
      _selOrNon[_itemKey] = { ...item, checked: checked }
      if (ts) {
        const { levels, sections, position } = ts
        _selOrNon[_itemKey].levels = levels
        _selOrNon[_itemKey].sections = sections
        _selOrNon[_itemKey].position = position
      }
    })
    sportsData.existing = _.sortBy(sportsData.existing, 'name')
    sportsData.selected = _.sortBy(sportsData.selected, 'name')
    sportsData.nonSelected = _.sortBy(sportsData.nonSelected, 'name')
  }

  return sportsData

}

/**
 * 
 * @param {*} state 
 * @param {*} homeAway 
 * @param {*} gridMatches 
 * @param {*} gameScoringType 
 * @returns matches_combined, crossoverMatches, seasonTeams
 */
const createTheSeasonMatches = (database_fns, mainDb, seasonMatchesProps, matches_season) => {
  const { matches, crossoverMatches } = createScheduledMatches(database_fns, mainDb, seasonMatchesProps, matches_season)
  return { matches, crossoverMatches }
}

const getSelectedPlayoffInfo = (state) => {

  const { playoff_info, playoff_matchInfo } = state
  const { playoffDates_selected, playoffLevelTeams } = playoff_info ?? {}
  const { matches } = playoff_matchInfo ?? {}

  const _playoffInfo = {
    playoffDates: playoffDates_selected,
  }

  const _plt = {}

  if (playoffLevelTeams) {
    _.forEach(playoffLevelTeams, (level, levelKey) => {
      _plt[levelKey] = []
      _.forEach(level, (team) => {
        const { id, levels, sections, name, position, owp, seed } = team
        const _team = { id, levels, sections, name, position, owp }
        if (_.isNumber(seed)) { _team.seed = seed }
        _plt[levelKey].push(_team)
      })
    })
  }

  _playoffInfo.playoffLevelTeams = _plt

  return {
    dtu: { playoffInfo: _playoffInfo, playoffMatches: matches },
    dta: { playoffInfo: _playoffInfo, playoffMatches: matches }
  }
}

const getFullPlayoffInfo = (playoff_matchInfo, playoffLevel, allPlayoffLevels) => {

  const { matches, tournamentMatches } = playoff_matchInfo ?? {}

  const _matches = dataFix.removeEmpty(matches)

  if (playoffLevel) {
    return tournamentMatches[playoffLevel]
  } else if (allPlayoffLevels) {
    return tournamentMatches
  } else {
    return _matches
  }
}


const ammendNext = (next, levelKey, sectionCount) => {
  if (next && next[levelKey]) {
    next[levelKey][sectionCountTypes.checked] = sectionCount > 0 // boolean
    next[levelKey][sectionCountTypes.sectionCount] = sectionCount > 0 ? sectionCount : false // boolean
    if (next[levelKey].sections) {
      Object.keys(next[levelKey].sections).forEach(sk => {
        const section = next[levelKey].sections[sk]
        const { name } = section
        const _nameIndex = name.replace('Section ', '')
        section[sectionCountTypes.checked] = parseInt(_nameIndex) <= sectionCount
      })
    }
  }
}

/**
 * Adds a `_teamKey` prop to each school that has a team (team.parentKeys.schools)
 * @param {*} schools 
 * @param {*} teams 
 */
const getSchoolsWithTeams = (schools, teams) => {
  if (teams && schools) {
    _.forEach(teams, (team, tk) => {
      if (team && team.parentKeys && team.parentKeys.schools) {
        if (schools[team.parentKeys.schools]) {
          schools[team.parentKeys.schools]._teamKey = tk
        }
      }
    })
  }
}

/**
 * 
 * @param {object} data 
 * @param {object} pathViews 
 * @param {boolean} forSeason 
 * @returns an object with `teams` object created from the data.selected object
 */
const getTeamsFromSelectedData = (data, pathViews, forSeason) => {
  const { selected } = data
  const _teams = {}
  if (selected) {
    Object.keys(selected).forEach(key => {
      const selectedItem = selected[key]
      const { name, _itemKey } = selectedItem
      if (forSeason) {
        _teams[_itemKey] = {
          name,
          sections: 0,
          levels: 0,
          position: 0,
        }
      } else {
        const teamKey = database_fns.get_docKey()
        _teams[teamKey] = {
          name,
          parentKeys: {
            organizations: pathViews.organizations,
            districts: pathViews.districts,
            schools: _itemKey,
            sports: pathViews.sports,
          }
        }
      }

    })
  }
  return { teams: _teams }
}

const updateTeamsSelected = (teams_info, schools_info, teamz_existing, teamsFromSchools) => {

  const _data = teamsFromSchools ? { ...schools_info } : { ...teams_info }

  const { existing: teams_existing } = teams_info ?? {}
  const { existing: schools_existing } = schools_info ?? {}

  const _existingTeams = teamsFromSchools ? schools_existing : teams_existing

  const _selected = {}
  const _nonSelected = {}
  const _existing = {}

  if (teamz_existing) {
    if (teamz_existing) {
      Object.keys(teamz_existing).forEach((key) => {
        const _team = teamz_existing[key]
        const { name, _itemKey, checked } = _team
        _existing[_itemKey] = { name, checked, _itemKey }
        if (checked) {
          _selected[_itemKey] = { name, checked: true, _itemKey }
        } else {
          _nonSelected[_itemKey] = { name, checked: false, _itemKey }
        }
      })
    }
  } else {
    if (_existingTeams) {
      Object.keys(_existingTeams).forEach((key) => {
        const _team = _existingTeams[key]
        const { name, _itemKey, checked } = _team
        _existing[_itemKey] = { name, checked: false, _itemKey }
        if (checked) {
          _selected[_itemKey] = { name, checked: true, _itemKey }
        } else {
          _nonSelected[_itemKey] = { name, checked: false, _itemKey }
        }
      })
    }
  }

  _data.selected = _selected
  _data.nonSelected = _nonSelected
  _data.existing = _existing
  _data._existing = _.sortBy(_existing, 'name')

  return _data

}